// src/shared/dashboard/widgets/AssignedCourseSyllabusWidget.tsx
//
// Dashboard widget: the member's assigned course syllabus, embedded under the
// hero so the home page reads banner + progress (the hero) + the program
// itself. Renders the generic CourseProgramView, the same wrapper the course
// page uses — the widget only supplies which course to show.
import { useLanguage } from "@/shared/i18n/LanguageContext";
import { useVertical } from "@/shared/contexts/VerticalContext";
import { CourseProgramView } from "@/shared/components/course/CourseProgramView";
import { CRISIS_PROGRAM_COURSE_ID } from "@/shared/lib/cohortCourse";
import { registerWidget } from "@/shared/dashboard/widgets/registry";
import type { WidgetProps } from "@/shared/dashboard/widgets/types";

function AssignedCourseSyllabusWidgetImpl(_: WidgetProps) {
  const { locale } = useLanguage();
  // The workspace's assigned course when there is one; otherwise the cohort
  // program this widget was built for, until that cutover lands.
  const { defaultCourseId } = useVertical();
  return (
    <CourseProgramView
      courseId={defaultCourseId || CRISIS_PROGRAM_COURSE_ID}
      locale={locale}
      embedded
    />
  );
}

registerWidget({
  id: "assignedCourseSyllabus",
  component: AssignedCourseSyllabusWidgetImpl,
  supportedSlots: new Set(["mainColumn"]),
  displayName: "Assigned course syllabus",
});

export const AssignedCourseSyllabusWidget = AssignedCourseSyllabusWidgetImpl;
